import { CollectionAction } from '../collection-action.interface';
import { CollectionState } from '../collection-state.interface';

const onError = (state: CollectionState, action: CollectionAction) => ({
  ...state,
  isUpdating: false,
  errorMessage: action.error || action.payload.errorMessage,
});

export default onError;
